import QxHome from '@/components/QxHome.vue';
import Media from '@/components/Media.vue';
import Adzone from '@/components/Adzone.vue';
import Report from '@/components/Report.vue';
import Page403 from '@/components/Page403.vue'
import Page404 from '@/components/Page404.vue'
import Index from '@/components/Index.vue'
import DeveloperAgreement from '@/components/legal/DeveloperAgreement.vue'
import DeveloperNorms from '@/components/legal/DeveloperNorms.vue'
import PrivacyPolicy from '@/components/legal/PrivacyPolicy.vue'
import DeveloperGuide from '@/components/legal/DeveloperGuide.vue'
import AdzoneEdit from '@/components/AdzoneEdit.vue';
import InstalledListCallback from '@/components/InstalledListCallback.vue';
import PackageNameEdit from '@/components/PackageNameEdit.vue';
import PackageNameBatchEdit from '@/components/PackageNameBatchEdit.vue';
import DeviceTargetingConfig from '@/components/DeviceTargetingConfig.vue';


let route =  {
  mode: 'history',
  routes: [
    {
      path: '/platform/index',
      name: 'index',
      component: Index,
    },
    {
      path: '*',
      name: '404',
      component: Page404,
      meta: {
        title: "找不到页面"
      }
    },
    {
      path: '/platform/403',
      name: '403',
      component: Page403,
      meta: {
        title: "无权限"
      }
    },
    {
      path: '/platform/developerAgreement',
      name: 'developerAgreement',
      component: DeveloperAgreement
    },
    {
      path: '/platform/developerNorms',
      name: 'developerNorms',
      component: DeveloperNorms
    },
    {
      path: '/platform/privacyPolicy',
      name: 'privacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/platform/developerGuide',
      name: 'developerGuide',
      component: DeveloperGuide
    },
    {
      path: '/platform/',
      component: QxHome,
      children: [
        // {
        //   path: '403',
        //   name: '403',
        //   component: Page403
        // },
        {
          path: 'media',
          name: 'media',
          component: Media
        },
        {
          path: 'adzone',
          name: 'adzone',
          component: Adzone
        },
        {
          path: 'deviceTargetingConfig',
          name: 'deviceTargetingConfig',
          component: DeviceTargetingConfig
        },
        {
          path: 'adzone/new',
          name: 'adzoneNew',
          component: AdzoneEdit
        },
        {
          path: 'adzone/:adzoneId',
          name: 'adzoneEdit',
          component: AdzoneEdit
        },
        {
          path: 'reportAccount',
          name: 'reportAccount',
          component: Report
        },
        {
          path: 'reportMedia',
          name: 'reportMedia',
          component: Report
        },
        {
          path: 'reportAdzone',
          name: 'reportAdzone',
          component: Report
        },
        {
          path: 'installedListCallback',
          name: 'installedListCallback',
          component: InstalledListCallback
        },
        {
          path: 'packageName/new',
          name: 'packageNameNew',
          component: PackageNameEdit
        },
        {
          path: 'packageName/:id',
          name: 'packageNameEdit',
          component: PackageNameEdit
        },
        {
          path: 'packageName/batch/edit',
          name: 'packageNameBatchEdit',
          component: PackageNameBatchEdit
        },
      ]
    },
    
  ]

};

export default route;
